module.exports = __webpack_public_path__ + "static/img/video_image0.e754751a.jpeg";